export default __webpack_public_path__ + "static/media/1973.4c35e5b6.png";